﻿{
  "behavioral_goals": [
    {
      "goal": "Self injury",
      "description": "By May 25, 2018, Jane will display no more than 3 self-injurious behaviors over the course of one week as measured by teacher/nurse charted records. (SPED uses a SMART goal approach) SMART - Specific, Measurable, Achievable, Relevant, Time Bound."
    },
    {
      "goal": "Aggression",
      "description": "By May 31, 2018, Jim will decrease the amount of verbal threats to other students to not more than 2 times per day as measured by teacher record/charts."
    },
    {
      "goal": "Tantrum",
      "font-family": true,
      "description": "The student will increase in positive, peaceful interactions with adults and peers at school 80% of the school day."
    },
    {
      "goal": "Classroom Disruption",
      "font-family": true,
      "description": "The student will decrease in outbursts to the peers and yelling at the teacher at school to only 50% of the school day."
    },
    {
      "goal": "Property Destruction",
      "description": "By ….., Student will refrain from destroying school property 100% of the time by utilizing aggression reducing tools such as squeeze ball, …. as measured by….."
    },
    {
      "goal": "Off-Task",
      "description": "Student will increase time on task behavior to 12 minutes during direct instruction."
    },
    {
      "goal": "Preparedness",
      "description": "The student will arrive for class on time and prepared (with appropriate class materials) 80% of the school day."
    },
    {
      "goal": "Socially inappropriate comments, statements, etc.",
      "description": "The student will decrease their socially inappropriate comments and statements to adults and peers to only 50% of the school day."
    },
    {
      "goal": "Other Unsafe or Disruptive Behavior",
      "description": "The student will decrease their unsafe behavior (list that behavior here) to zero times a day while at school. The FBA would show how many times the student displays certain unsafe or disruptive behaviors. You can write the goal to decrease or increase using specific numbers."
    }
  ],
"note": "Districts are different everywhere as I am sure you have seen.\nSPED laws allow states to interpret and incorporate their own\nnuances but every student has to have goals not necessarily\nbenchmarks within the goals. Progress of goals have to be\nreported to parents each time the gen ed reports are given and\nare many times just a short blurb with the most recent to\nsupport the annual goal."
}
